// extracted by mini-css-extract-plugin
export default {"title":"style_title__X3eP-","name":"style_name__--MGo"};